import {onBeforeUnmount, onMounted} from 'vue'
import '@/components/assistant/assistant-print.css'
import {useI18n} from 'vue-i18n'
import {useAssistantStore} from '@/stores/assistant'

const PRINT_MODE_CLASS = 'assistant-print-mode'

function enableAssistantPrintMode() {
  document.body.classList.add(PRINT_MODE_CLASS)
}

function disableAssistantPrintMode() {
  document.body.classList.remove(PRINT_MODE_CLASS)
}

export function useAssistantPrint() {
  const {t} = useI18n()
  const assistantStore = useAssistantStore()

  let originalDocumentTitle: string | null = null

  function resolvePrintTitle() {
    const title = assistantStore.activeConversation?.title
    return title || t('assistant.untitled')
  }

  function applyPrintTitle() {
    if (originalDocumentTitle === null) {
      originalDocumentTitle = document.title
    }

    document.title = resolvePrintTitle()
  }

  function restoreDocumentTitle() {
    if (originalDocumentTitle === null) {
      return
    }

    document.title = originalDocumentTitle
    originalDocumentTitle = null
  }

  function onBeforePrint() {
    if (!assistantStore.isVisible) {
      return
    }

    enableAssistantPrintMode()
    applyPrintTitle()
  }

  function onAfterPrint() {
    disableAssistantPrintMode()
    restoreDocumentTitle()
  }

  function printConversation() {
    enableAssistantPrintMode()
    applyPrintTitle()
    window.print()
  }

  onMounted(() => {
    window.addEventListener('beforeprint', onBeforePrint)
    window.addEventListener('afterprint', onAfterPrint)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('beforeprint', onBeforePrint)
    window.removeEventListener('afterprint', onAfterPrint)
    disableAssistantPrintMode()
    restoreDocumentTitle()
  })

  return {
    printConversation,
  }
}
